import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../../notification/Notification";
import { useTranslation } from "react-i18next";

const ProjectsSelect = ({
  checkedProjects,
  setCheckedProjects,
  isObject = true,
  defaultOption = false,
  label = "Project"
}) => {
  const { t } = useTranslation("otherInterface");
  const [userSupportProjects, setUserSupportProjects] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [fetchingUserSupportProjects, setFetchingUserSupportProjects] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/user-support-projects", userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setUserSupportProjects(response.data['hydra:member']);
        setFetchingUserSupportProjects(false);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, []);

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedProjects(data);
  };

  if (forbidden) {
    return "Forbidden";
  }

  if (fetchingUserSupportProjects) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(userSupportProjects).length === 0) {
    return "Empty ProjectsContainer";
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <Autocomplete
          options={(isObject ? userSupportProjects.map(userSupportProject => userSupportProject.project) : userSupportProjects.map(userSupportProject => userSupportProject.project.name)) || []}
          value={checkedProjects || null}
          onChange={(event, checkedProjects) => setCheckedProjects(checkedProjects)}
          getOptionLabel={(option) => isObject ? option.name : option}
          renderInput={(params) => (
            <TextField {...params} label={label === "Project" ? t("project.title") : ""} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default ProjectsSelect;